import { track } from "@vercel/analytics";
import type { PublicCycleLinkStatus } from "@/lib/v2/publicCycleLinkStatus";

/** Fired when a public invite link resolves to a terminal (non-active) state. */
export function trackPublicLinkTerminalView(status: Exclude<PublicCycleLinkStatus, "active">) {
  track("public_link_terminal_view", { status });
}
